import React from 'react'
import { COLORES } from '../../../config/colores'
import OperacionesPlanDeEmbarqueBodega from '../components/planDeEmbarque/OperacionesPlanDeEmbarqueBodega'

export const EMPLY_PLAN_DE_EMBARQUE_BODEGA = {
  buque: '',
  fechaDeReferencia: '',
  bodega: '',
  paisDestino: '',
  cereal: '',
  cerealVariedad: '',
  peso: ''
}

export const COLUMNS = [
  {
    name: 'bodega',
    label: 'Bodega',
    options: {
      filter: false,
      sort: false,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox'
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'pesoTotal',
    label: 'Peso (Kg.)',
    options: {
      filter: false,
      sort: false,
      total: true
    }
  },
  {
    name: 'paisDestino',
    label: 'Pais Destino',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'detalleBodega',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: detalle => {
        return <OperacionesPlanDeEmbarqueBodega detalleBodega={detalle} />
      }
    }

  }
]

export const COLUMNS_PLAN_DE_EMBARQUE_ACTIVO = [
  {
    name: 'buque',
    label: 'Buque',
    options: {
      filter: false,
      sort: false,
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          color: 'white',
          background: COLORES.blue.primaryDark,
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'pesoTotal',
    label: 'Peso total',
    options: {
      sort: true,
      filter: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (peso) => {
        return (<><b>{peso.toLocaleString('es-ES')}</b> kg.</>)
      }
    }
  }
]
